/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ChangePasswordInput } from '../models/ChangePasswordInput';
import type { CreateUserInput } from '../models/CreateUserInput';
import type { UpdateUserClaimsInput } from '../models/UpdateUserClaimsInput';
import type { UpdateUserInput } from '../models/UpdateUserInput';
import type { UserDetailDto } from '../models/UserDetailDto';
import type { UserDto } from '../models/UserDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class UserService {
    /**
     * @param term
     * @returns UserDto Success
     * @throws ApiError
     */
    public static listUsers(
        term?: string,
    ): CancelablePromise<Array<UserDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/User',
            query: {
                'term': term,
            },
        });
    }
    /**
     * @param requestBody
     * @returns UserDto Success
     * @throws ApiError
     */
    public static createUser(
        requestBody?: CreateUserInput,
    ): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/User',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param userId
     * @returns UserDetailDto Success
     * @throws ApiError
     */
    public static getUserById(
        userId: number,
    ): CancelablePromise<UserDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/User/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param requestBody
     * @returns UserDto Success
     * @throws ApiError
     */
    public static updateUser(
        userId: number,
        requestBody?: UpdateUserInput,
    ): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/v1/User/{userId}',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param userId
     * @returns UserDto Success
     * @throws ApiError
     */
    public static deleteUser(
        userId: number,
    ): CancelablePromise<UserDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/v1/User/{userId}',
            path: {
                'userId': userId,
            },
        });
    }
    /**
     * @param userId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static updateUserClaims(
        userId: number,
        requestBody?: UpdateUserClaimsInput,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/User/{userId}/Claims',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param userId
     * @param requestBody
     * @returns any Success
     * @throws ApiError
     */
    public static setPassword(
        userId: number,
        requestBody?: ChangePasswordInput,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/v1/User/{userId}/Password',
            path: {
                'userId': userId,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
